export const OAUTH2_REST_TEMPLATE = 'OAuth 2 API';
export const OAUTH2_GENERIC_REST_TEMPLATE = 'OAuth 2 Generic REST API';
export const OAUTH1a_REST_TEMPLATE = 'OAuth 1a API';
export const OAUTH1_GENERIC_REST_TEMPLATE = 'OAuth 1 Generic REST API';
export const ZENDESK_REST_TEMPLATE = 'Zendesk API';
export const BOX_REST_TEMPLATE = 'Box API';
export const DROPBOX_REST_TEMPLATE = 'Dropbox API';
export const INTUIT_QUICKBOOKS_REST_TEMPLATE = 'Intuit QuickBooks API';
export const GBQ_TEMPLATE = 'Google Big Query';
export const GCS_TEMPLATE = 'Google Cloud Storage';
export const GDRIVE_TEMPLATE = 'Google Drive';
export const SHAREPOINT_TEMPLATE = 'SharePoint';
export const PUBSUB_TEMPLATE = 'Google Pub/Sub';
